import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import React, { useState } from "react";
import InsigniaProduct from "../components/MainPageComponents/insignia";
import KitsDescription from "../components/KitsComponents/Kitsdescription";
import Kits from "../components/MainPageComponents/kits";
import { Button, Box, Typography } from "@mui/material";

const KitsView = () => {
  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
  };

  return (
    <Box>
      <Header />
      <KitsDescription />

      {/* Category selector section */}
      <Box
        sx={{
          maxWidth: 1100,
          mx: "auto",
          px: { xs: 2, md: 4 },
          pt: { xs: 3, md: 4 },
          pb: { xs: 4, md: 6 },
          borderTop: "1px solid rgba(255,255,255,0.08)",
        }}
      >
        <Box
          component="span"
          sx={{
            display: "block",
            width: "56px",
            height: "5px",
            borderRadius: "3px",
            backgroundColor: "#209be8",
            mx: "auto",
            mb: 2,
          }}
        />
        <Typography
          sx={{
            textAlign: "center",
            color: "#f2f2f2",
            fontWeight: 600,
            fontSize: { xs: "1.5rem", md: "2rem" },
          }}
        >
          Selecciona tu carrera para ver los kits disponibles
        </Typography>

        {/* Responsive container for category buttons */}
        <Box
          sx={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: { xs: 1.5, md: 2 },
            mt: { xs: 3, md: 5 },
          }}
        >
          {["Mecatrónica", "Electrónica", "Computadores", "Otros Kits"].map((category) => {
            const isSelected = selectedCategory === category;
            return (
              <Button
                key={category}
                onClick={() => handleCategorySelect(category)}
                sx={{
                  height: "3rem",
                  px: 3,
                  borderRadius: "999px",
                  fontWeight: 600,
                  textTransform: "none",
                  fontSize: "1rem",
                  backgroundColor: isSelected ? "#faad2b" : "#209be8",
                  color: "#000",
                  boxShadow: isSelected
                    ? "0 12px 28px -10px rgba(250,173,43,0.5)"
                    : "0 12px 28px -10px rgba(32,155,232,0.5)",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#faad2b",
                    transform: "translateY(-3px)",
                  },
                }}
              >
                {category}
              </Button>
            );
          })}
        </Box>
      </Box>

      {/* Conditional rendering for category-specific content */}
      {selectedCategory === "Mecatrónica" && (
        <>
          <InsigniaProduct
            image="/images/ccca.png"
            title="Kit Laboratorio de Circuitos Eléctricos en CC/CA"
            description="Volteon Electronics te trae el mejor Kit para el curso de Laboratorio de Circuitos en CC/CA, 
                        ahora con una nueva y mejorada imagen, nuevo material didáctico y superior calidad de empacado. 
                        Este kit de laboratorio ha sido mejorado en cada una de sus entregas durante más de 2 años."
            buttonText="Reserva el tuyo"
            buttonLink="/kits/ccca"
          />
          <Kits
            image="/images/Analogica.png"
            title="Kit Laboratorio de Electrónica Analógica"
            description="Volteon Electronics te trae el mejor Kit para el curso de Electrónica Analógica, ahora con una nueva y mejorada imagen, 
                        nuevo material didáctico y nueva selección de componentes. Este kit ha sido rediseñado, contiene aquellos componentes que son nuevos 
                        para el curso; para que pueda ser complementado con los componentes que ya tienes de cursos anteriores."
            buttonText="Reserva el tuyo"
            buttonLink="/kits/analogica"
          />
          <InsigniaProduct
            image="/images/digital.png"
            title="Kit Laboratorio de Electrónica Digital"
            description="Con este kit tendrás todo lo que necesitas para el Laboratorio de Electrónica Digital."
            buttonText="Reserva el tuyo"
            buttonLink="/kits/digital"
          />
        </>
      )}
      {selectedCategory === "Electrónica" && (
        <InsigniaProduct
          image="/images/mediciones.png"
          title="Kit de Laboratorio de Mediciones Eléctricas"
          description="Volteon Electronics te trae el nuevo Kit para el curso de Laboratorio de Mediciones Eléctricas, con todos los componentes 
                        que vas a necesitar en una gran presentación."
          buttonText="Reserva el tuyo"
          buttonLink="/kits/mediciones"
        />
      )}
      {selectedCategory === "Computadores" && (
        <InsigniaProduct
          image="/images/Computadores.png"
          title="Kit de Laboratorio de Circuitos Eléctricos"
          description="Volteon Electronics te trae el nuevo y mejorado Kit para el Laboratorio de Circuitos Eléctricos de Computadores."
          buttonText="Reserva el tuyo"
          buttonLink="/kits/circuitosCE"
        />
      )}

      {selectedCategory === "Otros Kits" && (
        <InsigniaProduct
          image="/images/KitsArduino.png"
          title="Kits de Arduino"
          description="Si querés empezar a utilizar Arduino para realizar todo tipo de proyectos con una amplia variedad de sensores, esta es tu mejor opción.
                Desde distintos tipos de motores hasta sensores infrarrojos y de temperatura, descubrí cuál sensor sorpresa te toca en tu kit y ampliá tus conocimientos."
          buttonText="Conocé más"
          buttonLink="/insignia/KitsArduino"
        />
      )}

      <Footer />
    </Box>
  );
};

export default KitsView;
